const md = '1023px';
const sd = '540px';
const set_point = 300; //display fixed header
const set_speed = 600; //scroll speed


$(window).on("load resize orientationchange", function () {
	if (window.matchMedia("(max-width: 1023px)").matches) {
		// ▽ only SP
		int_md();
		$('.hl-meta').heightLine('destroy');

	} else {
		// ▽ tab over
		int_lg()
		//let rellax = new Rellax('.rellax');
		$('.hl-meta').heightLine({});

	}

});
	
jQuery(document).ready(function ($) {
	/* floating header */
	const clone_header = $('#js-header').children();
	clone_header.clone(true).prependTo('#js-fixed-header');

	/* offcanvas */
	$('#js-nav-global').clone(true).prependTo($('#js-nav-offcanvas'));

	custom(); //ios

	/* slide */
	//top page
	const slide = new Swiper('.c-slide', {
		effect: 'fade',
		speed: 1000,
		autoplay: {
			delay: 5000,
		  },
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true
		  },

	});


	//return top button
	const topBtn = $("#movetop");
	topBtn.on("click", function () {
		movetop();
	});
	

	//ページ内リンクを回避
  /*
	$('a[href^="#"]').on("click", function (e) {
		e.preventDefault();

		const speed = 500;
		const href= $(this).attr("href");
		const target = $(href == "#" || href == "" ? 'html' : href);
		let offset = 0;//$('#js-header').outerHeight();

		const position = target.offset().top - offset;

		$('body,html').animate(
			{
				scrollTop:position
			},
			speed,
			'swing'
		);
		//ページ内リンクはオフカンバスを閉じる
		if( $(this).closest('.js-offcanvas').length > 0 ){
			console.log('toggle');
			$('body').removeClass('-drawer');
			$('.js-nav-toggle').removeClass('-close');
			//$('.js-offcanvas').fadeOut();
		}
		return false;
	});
*/
	$(".js-nav-toggle").off("click");
	$(".js-nav-toggle").on("click", function () {
		$('body').toggleClass('-drawer');
		$('.js-nav-toggle').toggleClass('-close')
		//$(".js-offcanvas").fadeToggle();
		return false;
	});


	//accodion
	$('.ac-toggle').on('click',function(){
		$(this).toggleClass('is-active');
		$(this).next('.ac-panel').slideToggle();
		$(this).parent().toggleClass('is-active');
	})

	//swap media
	if( $('.meta-large').length > 0 ){
		$('.meta-large:first-child').addClass('-display');
	}
	if( $('.swap-toggle').length > 0 ){
		$('.swap-toggle:first-child').addClass('is-active');
	}

	$('.swap-toggle').on('mouseenter',function(){
		$('.swap-toggle').removeClass('is-active');
		$(this).addClass('is-active');

		let display = $(this).attr('data-target');
		display = '.' + display;
		$('.meta-large').removeClass('-display');
		$( display ).addClass('-display');
		return false;

	});

});


let scroll = 0;
$(window).on('scroll',function () {
	//スクロール方向
	if($(this).scrollTop() < scroll ){
		$('html').removeClass('-down');
		$('html').addClass('-up');
	}else{
		$('html').removeClass('-up');
		$('html').addClass('-down');
	}

	scroll = $(this).scrollTop();
	//fixed header
	if ( scroll > set_point ) {
		$('#js-fixed-header').addClass('is-view');
	} else {
		$('#js-fixed-header').removeClass('is-view');
	}

});


function movetop(){
	const myPos = $("html").offset().top;
	$("html,body").animate(
		{
			scrollTop: myPos,
		},
		500,
		"swing"
	);
	return false;
}

//初期化
function int_md(){
	$(".sp-img").each(function () {
		$(this).attr("src", $(this).attr("src").replace("_pc", "_sp"));
	});
	$("html").removeClass("un-mobile");
	$("html").addClass("is-mobile has-offcanvas");

	$('.js-offcanvas').css('display','');
}

function int_lg(){
	$(".sp-img").each(function () {
		$(this).attr("src", $(this).attr("src").replace("_sp", "_pc"));
	});
	$("html").removeClass("is-mobile has-offcanvas");
	$("html").addClass("un-mobile");

	$("body").removeClass("-drawer");
	$(".js-offcanvas").hide();
	$(".js-nav-toggle").removeClass("is-active");
	$(".js-offcanvas-body").removeClass("-active");
}

//サファリ判定
function check_safari(){
	const ua = navigator.userAgent;
	if (ua.indexOf("iPhone") > 0 || ua.indexOf("iPad") > 0 || ua.indexOf('macintosh') > 0 && 'ontouchend' in document ) {
		const viewport = $('meta[name="viewport"]');
		const viewportContent = viewport.attr("content");
		viewport.attr("content", viewportContent + ", user-scalable=no");
		$('html').addClass('is-safari');
	}

}

//
function custom(){
	//auto target
	$("a[href^='http']").not('[href*="' + location.hostname + '"]').attr("target", "_blank");
	
	//selectのおまじない
	$('select').each(function(){
		$(this).wrap('<div class="c-field-select"></div>');
	});
	
	check_safari();
}

